import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { DashboardBuilderCoreModule } from '@sick-curie/dashboard-builder-core';
export * from '@sick-curie/dashboard-builder-core';
import { DashboardBuilderDataConverterModule } from '@sick-curie/dashboard-builder-data-converter';
export * from '@sick-curie/dashboard-builder-data-converter';
import { DashboardBuilderDefaultBindingsModule } from '@sick-curie/dashboard-builder-default-bindings';
export * from '@sick-curie/dashboard-builder-default-bindings';
import { DashboardBuilderDefaultDashboardModule } from '@sick-curie/dashboard-builder-default-dashboard';
export * from '@sick-curie/dashboard-builder-default-dashboard';
import { DashboardBuilderGenericTableElementModule } from '@sick-curie/dashboard-builder-elements-generic-table';
export * from '@sick-curie/dashboard-builder-elements-generic-table';
import { DashboardBuilderGridTableElementModule } from '@sick-curie/dashboard-builder-elements-grid-table';
export * from '@sick-curie/dashboard-builder-elements-grid-table';
import { DashboardBuilderImageViewerElementModule } from '@sick-curie/dashboard-builder-elements-image-viewer';
export * from '@sick-curie/dashboard-builder-elements-image-viewer';
import { DashboardBuilderWrappedElementsModule } from '@sick-curie/dashboard-builder-elements-wrapped-elements';
export * from '@sick-curie/dashboard-builder-elements-wrapped-elements';
import { DashboardBuilderServicesModule } from '@sick-curie/dashboard-builder-services';
export * from '@sick-curie/dashboard-builder-services';
import { DashboardBuilderViewModule } from '@sick-curie/dashboard-builder-view';
export * from '@sick-curie/dashboard-builder-view';
export * from '@sick-curie/dashboard-builder-models';
export * from '@sick-curie/dashboard-builder-ui-models';
export * from '@sick-curie/dashboard-builder-backend-api';

class DashboardBuilderModule {
}
DashboardBuilderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: DashboardBuilderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DashboardBuilderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.0", ngImport: i0, type: DashboardBuilderModule, imports: [CommonModule,
        DashboardBuilderWrappedElementsModule,
        DashboardBuilderViewModule,
        DashboardBuilderImageViewerElementModule,
        DashboardBuilderServicesModule,
        DashboardBuilderDefaultBindingsModule,
        DashboardBuilderDataConverterModule,
        DashboardBuilderGenericTableElementModule,
        DashboardBuilderGridTableElementModule,
        DashboardBuilderDefaultDashboardModule,
        DashboardBuilderCoreModule], exports: [DashboardBuilderWrappedElementsModule,
        DashboardBuilderViewModule,
        DashboardBuilderImageViewerElementModule,
        DashboardBuilderServicesModule,
        DashboardBuilderDefaultBindingsModule,
        DashboardBuilderDataConverterModule,
        DashboardBuilderGenericTableElementModule,
        DashboardBuilderGridTableElementModule,
        DashboardBuilderDefaultDashboardModule,
        DashboardBuilderCoreModule] });
DashboardBuilderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: DashboardBuilderModule, imports: [CommonModule,
        DashboardBuilderWrappedElementsModule,
        DashboardBuilderViewModule,
        DashboardBuilderImageViewerElementModule,
        DashboardBuilderServicesModule,
        DashboardBuilderDefaultBindingsModule,
        DashboardBuilderDataConverterModule,
        DashboardBuilderGenericTableElementModule,
        DashboardBuilderGridTableElementModule,
        DashboardBuilderDefaultDashboardModule,
        DashboardBuilderCoreModule, DashboardBuilderWrappedElementsModule,
        DashboardBuilderViewModule,
        DashboardBuilderImageViewerElementModule,
        DashboardBuilderServicesModule,
        DashboardBuilderDefaultBindingsModule,
        DashboardBuilderDataConverterModule,
        DashboardBuilderGenericTableElementModule,
        DashboardBuilderGridTableElementModule,
        DashboardBuilderDefaultDashboardModule,
        DashboardBuilderCoreModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: DashboardBuilderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        DashboardBuilderWrappedElementsModule,
                        DashboardBuilderViewModule,
                        DashboardBuilderImageViewerElementModule,
                        DashboardBuilderServicesModule,
                        DashboardBuilderDefaultBindingsModule,
                        DashboardBuilderDataConverterModule,
                        DashboardBuilderGenericTableElementModule,
                        DashboardBuilderGridTableElementModule,
                        DashboardBuilderDefaultDashboardModule,
                        DashboardBuilderCoreModule,
                    ],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    exports: [
                        DashboardBuilderWrappedElementsModule,
                        DashboardBuilderViewModule,
                        DashboardBuilderImageViewerElementModule,
                        DashboardBuilderServicesModule,
                        DashboardBuilderDefaultBindingsModule,
                        DashboardBuilderDataConverterModule,
                        DashboardBuilderGenericTableElementModule,
                        DashboardBuilderGridTableElementModule,
                        DashboardBuilderDefaultDashboardModule,
                        DashboardBuilderCoreModule,
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DashboardBuilderModule };
